import type { ReportLiveMapResponse } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export const useLiveMapKey = "reportLiveMap";

const REFRESH_MS = 60 * 1000;

/** A floor this minute, refreshed every minute while shown. */
export const useLiveMap = (floorId: string, isEnabled: boolean) =>
  useQuery<ReportLiveMapResponse>({
    queryKey: [useLiveMapKey, floorId],
    queryFn: async () => {
      const { result } = await api.client.reporting.liveMap(floorId);
      if (!result) {
        throw new Error("empty live map response");
      }
      return result;
    },
    enabled: isEnabled,
    refetchInterval: isEnabled ? REFRESH_MS : false,
    staleTime: REFRESH_MS
  });
